import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import api from './api/apiList';
import echarts from 'echarts';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/base.css';
import './assets/style/animate.css';
import './utils/common/commonHelper';

router.beforeEach((to, from, next) => {
  let isLogin = sessionStorage.getItem('userInfo');
  // let isLogin = sessionStorage.getItem('isLogin') || store.state.token
  if (to.name != 'login' && !isLogin) {
    return next({ path: '/login' });
  }
  next();
});

Vue.use(ElementUI);
Vue.prototype.$axios = axios;
Vue.prototype.$api = api;
Vue.prototype.$echarts = echarts;
Vue.prototype.$eventBus = new Vue();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
